import dashboard from 'Modules/Dashboard/resources/lang/fa-ir.js'
import acl from 'Modules/ACL/resources/lang/fa-ir.js'
import currency from 'Modules/Currency/resources/lang/fa-ir.js'
import region from 'Modules/Region/resources/lang/fa-ir.js'
import user from 'Modules/User/resources/lang/fa-ir.js'
import affiliate from 'Modules/Affiliate/resources/lang/fa-ir.js'
import auth from 'Modules/Auth/resources/lang/fa-ir.js'
import alert from 'Modules/Alert/resources/lang/fa-ir.js'
import help from 'Modules/Help/resources/lang/fa-ir.js'
import bank from 'Modules/Bank/resources/lang/fa-ir.js'
import exchange from 'Modules/Exchange/resources/lang/fa-ir.js'
import notification from 'Modules/Notification/resources/lang/fa-ir.js'
import operator from 'Modules/Operator/resources/lang/fa-ir.js'
import pair from 'Modules/Pair/resources/lang/fa-ir.js'
import paymentMethod from 'Modules/PaymentMethod/resources/lang/fa-ir.js'
import ramp from 'Modules/Ramp/resources/lang/fa-ir.js'
import rebitAccount from 'Modules/RebitAccount/resources/lang/fa-ir.js'
import recipient from 'Modules/Recipient/resources/lang/fa-ir.js'
import setting from 'Modules/Setting/resources/lang/fa-ir.js'
import testimonial from 'Modules/Testimonial/resources/lang/fa-ir.js'
import trade from 'Modules/Trade/resources/lang/fa-ir.js'
import transaction from 'Modules/Transaction/resources/lang/fa-ir.js'
import transfer from 'Modules/Transfer/resources/lang/fa-ir.js'
import verificationType from 'Modules/VerificationType/resources/lang/fa-ir.js'
import risk from 'Modules/Risk/resources/lang/fa-ir.js'

export default Object.assign({},
  dashboard,
  acl,
  currency,
  region,
  user,
  affiliate,
  auth,
  alert,
  help,
  bank,
  exchange,
  notification,
  operator,
  pair,
  paymentMethod,
  ramp,
  rebitAccount,
  recipient,
  setting,
  testimonial,
  trade,
  transaction,
  transfer,
  verificationType,
  risk
)
